import React from 'react';
import PropTypes from 'prop-types';
import { useReactlytics } from '@americanexpress/reactlytics';
import {
  Accordion,
  AccordionContent,
  AccordionPanel,
} from '@americanexpress/dls-react';
import clsx from 'clsx';
import { sanitize } from '@americanexpress/consumer-travel-base';
import styles from './Questions.scss';

const Question = ({ details }) => {
  const analytics = useReactlytics();
  const questionTrackingId = `faq-${details?.id}`;

  const handleClick = (event, id) => {
    analytics.track({
      event: {
        detail: questionTrackingId,
        element: event.target.tagName,
        id,
        type: 'click',
      },
    });
  };

  return (
    <Accordion onAccordionToggle={handleClick}>
      <AccordionPanel
        aria-label={details?.question}
        id={`collapsible-${details?.id}`}
        reactlytics={{ detail: 'test1' }}
        heading={<h3>{details?.question}</h3>}
      />
      <AccordionContent
        aria-labelledby={`collapsible-${details?.id}`}
        reactlytics={{ detail: 'test2' }}
      >
        <p
          className={clsx('pad pad-1-l-sm-down', styles.collapsibleTextBody)}
          /* eslint-disable-next-line react/no-danger -- content from oneCMS */
          dangerouslySetInnerHTML={{ __html: sanitize(details?.answer, { html: true }) }}
        />
      </AccordionContent>
    </Accordion>
  );
};

Question.propTypes = {
  details: PropTypes.shape({
    id: PropTypes.string,
    question: PropTypes.string,
    answer: PropTypes.string,
  }).isRequired,
};

export default Question;
